import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDropdown from "../../../Common/ReactDropdown";

const CreateRegion = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [location, setLocation] = useState({});
  const [factory, setFactory] = useState({});
  const [department, setDepartment] = useState({});
  const [asset, setAsset] = useState({});
  const [unit, setUnit] = useState({});
  const [error, setError] = useState({});
  // const [selectedFile, setSelectedFile] = useState({});
  const [isSelected, setIsSelected] = useState(false);
  const [staff, setStaff] = useState({});
  const [vendor, setVendor] = useState({});
  const [list, setList] = useState([
    { asset_id: "", unit_id: "", qty: "", desc: "" },
  ]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const resVendor = await Http.get("/vendor");
        setVendor(resVendor.data);

        const resStaff = await Http.get("/staff");
        setStaff(resStaff.data);

        const resLocation = await Http.get("/location");
        setLocation(resLocation.data);

        const resFactory = await Http.get("/factory");
        setFactory(resFactory.data);

        const resDepartment = await Http.get("/department");
        setDepartment(resDepartment.data);

        const resAsset = await Http.get("/asset");
        setAsset(resAsset.data);

        const resUnit = await Http.get("/unit");
        setUnit(resUnit.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    getCurrentDateInput();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  // const handleFileChange = (e) => {
  //   const fileArray = [];
  //   const files = e.target.files;
  //   Object.keys(files).forEach((key) => {
  //     fileArray.push(e.target.files[key]);
  //   });
  //   setSelectedFile(fileArray);
  //   setIsSelected(true);
  // };

  // Set Experience State
  const handleInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
  };

  const formSubmit = () => {
    // inputs.file = selectedFile;
    Http.post("/asset-maintenance-claim", inputs)
      .then((res) => {
        navigate("/asset-maintenence-claim", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  // const selectDrop=(e) =>
  //   setInputs((values) => ({
  //     ...values,
  //     factory_id: e.value.id,
  //   }))

  // const reactDropdownHandler = (field, prop) => (e) => {
  //   setInputs((values) => ({
  //     ...values,
  //     [field]: e.value[prop],
  //   }));
  // };

  const reactDropdownHandler = (field, prop) => (e) => {
    setInputs((values) => ({
      ...values,
      // [field]: e.value[prop],
      [field]: prop ? e.value[prop] : e.value,
    }));
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Asset Maintenance Claim</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Asset Maintenance Claim
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Asset <i className="fa fa-star required"></i>
                    </label>
                    {/* <select
                      className="form-control"
                      name="asset_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Asset </option>
                      {Array.from(asset).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={asset}
                      optitle={"name"}
                      onChange={reactDropdownHandler("asset_id", "id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Staff <i className="fa fa-star required"></i>
                    </label>
                    {/* <select
                      className="form-control"
                      name="staff_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Staff</option>
                      {Array.from(staff).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.card_no} - {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={staff}
                      optitle={"name"}
                      onChange={reactDropdownHandler("staff_id", "id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Vendor <i className="fa fa-star required"></i>
                    </label>
                    {/* <select
                      className="form-control"
                      name="vendor_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Vendor</option>
                      {Array.from(vendor).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.card_no} - {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={vendor}
                      optitle={"name"}
                      onChange={reactDropdownHandler("vendor_id", "id")}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label htmlFor="">Location</label>
                    {/* <select
                      className="form-control"
                      name="company_location_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Location</option>
                      {Array.from(location).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={location}
                      optitle={"name"}
                      onChange={reactDropdownHandler(
                        "company_location_id",
                        "id"
                      )}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">Factory</label>
                    {/* <select
                      className="form-control"
                      name="factory_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Factory</option>
                      {Array.from(factory).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={factory}
                      optitle={"name"}
                      onChange={reactDropdownHandler("factory_id", "id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">Department</label>
                    {/* <select
                      className="form-control"
                      name="department_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Department</option>
                      {Array.from(department).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={department}
                      optitle={"name"}
                      onChange={reactDropdownHandler("department_id", "id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Expected Receive Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="expected_receive_date"
                      value={inputs.expected_receive_date || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      value={inputs.amount || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  {/* <div className="col-lg">
                    <label>Attachment</label>
                    <input
                      type="file"
                      name="attachment"
                      className="form-control"
                      multiple
                      onChange={handleFileChange}
                    />
                  </div> */}
                </div>
                <div className="row mt-3">
                  <div className="col-6"></div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default CreateRegion;
